module.exports = __webpack_public_path__ + "static/media/24.3983df7d.JPG";